import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from 'api/constants';
import { resolve } from 'api/resolve';
import { SNACKBAR_STORE } from 'state/snackbar/snackbarStore';

import { useProposalApi } from '../proposal-api';
import type { CreateProposalPayload } from '../types';

export function useCreateProposal() {
  const { create } = useProposalApi();
  const queryClient = useQueryClient();
  const { ALL_PROPOSALS } = QUERY_KEYS;

  return useMutation({
    mutationFn: ({ projectId, payload }: { projectId: string; payload: CreateProposalPayload }) => {
      return resolve(create(projectId, payload));
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [ALL_PROPOSALS, variables.projectId] });
    },
    onError: () => {
      SNACKBAR_STORE.getState().showSnackbar('Failed to create proposal', 'error', true);
    }
  });
}
